import React from "react";
import { Snackbar, Alert } from "@mui/material";
import type { Toast, ToastType } from "../hooks/useToast";

type Props = {
  toasts: Toast[];
  onClose: (id: string) => void;
};

const severityMap: Record<ToastType, "success" | "error" | "warning" | "info"> = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
};

export default function ToastContainer({ toasts, onClose }: Props) {
  return (
    <>
      {toasts.map((toast, index) => (
        <Snackbar
          key={toast.id}
          open={true}
          autoHideDuration={4000}
          onClose={() => onClose(toast.id)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          sx={{
            bottom: { xs: 16, sm: 24 } + index * 80,
          }}
        >
          <Alert
            onClose={() => onClose(toast.id)}
            severity={severityMap[toast.type]}
            sx={{
              width: "100%",
              minWidth: "300px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            }}
          >
            {toast.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
}
